const NAME_BOUNDARY = /(^|[\s'-])([a-z])/g;

const isUniformCase = (value) =>
  value === value.toUpperCase() ||
  value === value.toLowerCase();

export const formatDisplayName = (value) => {
  if (typeof value !== 'string') {
    return value || '';
  }

  const trimmed = value.trim().replace(/\s+/g, ' ');

  if (!trimmed || !isUniformCase(trimmed)) {
    return trimmed;
  }

  return trimmed
    .toLowerCase()
    .replace(NAME_BOUNDARY, (match, boundary, letter) =>
      `${boundary}${letter.toUpperCase()}`
    );
};

export const buildDisplayName = (...parts) =>
  formatDisplayName(parts.filter(Boolean).join(' '));


export const getShortName = (givenNames) => {
  const formatted = formatDisplayName(givenNames);

  if (!formatted) {
    return '';
  }

  return formatted.split(' ')[0];
};
